import { ErrorHandler, Injectable } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class AppErrorHandler implements ErrorHandler {
  public handleError(error) {
    this.logError(error)
    throw error
  }

  public logError(error: any) {
    if (error instanceof HttpErrorResponse) {
      // @todo consier formatting a standard api error response
      // tslint:disable-next-line:no-console
      console.error('HTTP error.', error.message, 'Status code:', (<HttpErrorResponse>error).status)
    } else if (error instanceof TypeError) {
      // tslint:disable-next-line:no-console
      console.error('Type error.', error.message)
    } else if (error instanceof Error) {
      // tslint:disable-next-line:no-console
      console.error('General error.', error.message)
    } else {
      // tslint:disable-next-line:no-console
      console.error('Unknown error', error)
    }
  }
}
